<nb-card class="plate__container">
  <nb-card-header i18n="@@AdditionalPhotos">Фотографии
    <span class="add" (click)="showUploadForm = !showUploadForm">
        <button i18n-nbTooltip="@@Add" nbTooltip="Добавить" nbButton size="tiny" type="button">
          <nb-icon [icon]="showUploadForm ? 'minus-outline' : 'plus-outline'"></nb-icon>
        </button>
      </span>
  </nb-card-header>

  <div class="file-card-body" *ngIf="showUploadForm">
    <label i18n="@ClickOrDragImage" for="uploader-input"
           class="well my-drop-zone"
           ng2FileDrop
           [ngClass]="{'file-over': hasDropZoneOver}"
           (fileOver)="fileOver($event)"
           (onFileDrop)="upload()"
           [uploader]="uploader">
      <nb-icon icon="upload-outline"/>
      Кликните или перетащите сюда фото</label>
    <input type="file" ng2FileSelect (change)="upload()" [uploader]="uploader" multiple id="uploader-input" style="display:none"/>

    <div class="my-drop-zone-info" style="max-width: 380px; margin: 10px auto 0" *ngIf="dangerText">
      {{ dangerText }}
    </div>
  </div>

  <div *ngIf="model?.pictures?.length">
    <div class="drag-drop-list" cdkDropListGroup>
      <div *ngFor="let picture of model.pictures; let i=index"
           cdkDropList (cdkDropListDropped)="drop($event)" class="drag-drop-box photos"
           [cdkDropListData]="{index:i}">
        <div cdkDrag class="photo">
          <img [src]="getImageUri(picture)" alt="" (error)="handleImageError($event)" loading="lazy">
          <div class="icons">
            <button i18n-nbTooltip="@@Delete" nbTooltip="удалить" status="danger" (click)="removeAdditionalPicture(picture)" type="button" nbButton size="tiny" class="delete">
              <nb-icon icon="close"></nb-icon>
            </button>
            <button status="control" (click)="openPicture(i)" type="button" nbButton size="medium" class="zoom">
              <nb-icon icon="maximize-outline"></nb-icon>
            </button>
          </div>
          <label *ngIf="i===0">основное</label>
        </div>
      </div>
    </div>
  </div>
</nb-card>

<image-preview *ngIf="model?.pictures?.length" #preview [title]="model.header" [showMeta]="true"/>
